// Traducciones en inglés para la sección de cancelación de suscripción
const unsubscribe = {
  title: "Unsubscribe",
  noEmail: "No email provided. Unable to unsubscribe.",
  success: "You have been successfully unsubscribed.",
  error: "There was an error processing your unsubscribe request.",
  buttonBack: "Back to Home"
}; 

export default unsubscribe; 